import React from 'react';
import { HomeHero } from '../components/home/HomeHero';
import { HomeFoundations } from '../components/home/HomeFoundations';
import { HomeDemoCenter } from '../components/home/HomeDemoCenter';
import { HomeActionExamples } from '../components/home/HomeActionExamples';
import { HomePillars } from '../components/home/HomePillars';
import { HomeAvailability } from '../components/home/HomeAvailability';
import { HomeInitiatives } from '../components/home/HomeInitiatives';
import { HomeCTA } from '../components/home/HomeCTA';
export function HomePage() {
  return <>
      <HomeHero data-id="element-2816" data-mp="36qbuq9s658h5" />
      <HomeFoundations data-id="element-2817" data-mp="36q26orqopbe3" />
      <HomeDemoCenter data-id="element-2818" data-mp="36rdh3aemxhe6" />
      <HomeActionExamples data-id="element-2819" data-mp="36rmy48hpce7q" />
      <HomePillars data-id="element-2820" data-mp="36s50lmuyjoo3" />
      <HomeAvailability data-id="element-2821" data-mp="31z27ffu3eh8f" />
      <HomeInitiatives data-id="element-2822" data-mp="31ykb6j7fk30i" />
      <HomeCTA data-id="element-2823" data-mp="31yaob4hombz1" />
    </>;
}